import PropTypes from 'prop-types'
import { useState } from 'react'
import { Button, Box, Icon } from '@redriverpress/system'

import AddToClassDialog from 'Common/components/dialogs/AddToClassDialog'
import { CONTENT_TYPES } from 'Common/constants/contentTypes'

import { VideoDataShape } from '../constants/VideoPropType'

export default function AddVideoToClassButton({ video }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      <Button onClick={() => setIsDialogOpen(true)} small>
        <Box
          display='flex'
          alignItems='center'
          style={{ whiteSpace: 'nowrap' }}
        >
          <Icon icon='plus' pr={2} />
          Add to class
        </Box>
      </Button>

      <AddToClassDialog
        open={isDialogOpen}
        onOpenChange={isOpen => setIsDialogOpen(isOpen)}
        onCancel={() => setIsDialogOpen(false)}
        onSave={() => setIsDialogOpen(false)}
        content={video}
        contentType={CONTENT_TYPES.video}
      />
    </>
  )
}

AddVideoToClassButton.propTypes = {
  video: PropTypes.shape(VideoDataShape).isRequired,
}
